import hellojs from '../../vendor/hello.js'

export default function (type) {
  return hellojs
    // install microsoft driver
    .init({
      onedrive: {
        name: 'OneDrive',

        base: 'https://login.microsoftonline.com/',

        oauth: {
          version: 2,
          auth: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
          grant: 'https://login.microsoftonline.com/common/oauth2/v2.0/token',
          response_type: 'code',
        },

        scope: {
          appfiles: 'Files.ReadWrite.AppFolder',
          files: 'Files.ReadWrite.All',
          sites: 'Sites.Read.All',
          groups: 'Group.Read.All',
          offline: 'offline_access',
        },

        scope_delim: ' ',
      }
    })
    // Initialize Driver instance
    .init(
      {
        onedrive: type === 'full'
          ? window.Drupal.settings.INTEGRATIONS_ONEDRIVE_FULL_APP_ID // Use full access app
          : window.Drupal.settings.INTEGRATIONS_ONEDRIVE_APP_ID      // Use AppFolder limited app
      },
      {
        redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
        oauth_proxy: `${window.location.origin}/rpc/integrations/oauth_proxy`,
        scope: 'files offline_access',
        prompt: 'consent',
      }
    )('onedrive'); // spawn an instance of the driver that one can call .login() on
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/OneDriveAuthenticator.js